"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _payouts = require("@module/payouts");

var _notFound = _interopRequireDefault(require("@module/not-found"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _Header = _interopRequireDefault(require("./Header"));

var _Filter = _interopRequireDefault(require("./Filter"));

var _Table = _interopRequireDefault(require("./Table"));

var _Paging = _interopRequireDefault(require("./Paging"));

var _ListCount = _interopRequireDefault(require("./ListCount"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function PayoutPage() {
  var isNotFound = (0, _reactRedux.useSelector)(_payouts.selectIsNotFound);

  if (isNotFound) {
    return /*#__PURE__*/_react["default"].createElement(_notFound["default"], null);
  }

  try {
    return /*#__PURE__*/_react["default"].createElement("section", {
      className: "page"
    }, /*#__PURE__*/_react["default"].createElement("article", {
      className: "page__content",
      "data-locator": "payouts.content"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['content']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['header']
    }, /*#__PURE__*/_react["default"].createElement(_Header["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['filter']
    }, /*#__PURE__*/_react["default"].createElement(_Filter["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['list']
    }, /*#__PURE__*/_react["default"].createElement(_Table["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['controls']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['count']
    }, /*#__PURE__*/_react["default"].createElement(_ListCount["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['paging']
    }, /*#__PURE__*/_react["default"].createElement(_Paging["default"], null))))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement("section", {
      className: "page"
    }, /*#__PURE__*/_react["default"].createElement("article", {
      className: "page__content",
      "data-locator": "payouts.content"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['content']
    }, /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    }))));
  }
}

var _default = PayoutPage;
exports["default"] = _default;